import './index.css';
import { jsx } from 'react/jsx-runtime';
import { useRef, useState, useEffect } from 'react';
import { useKeyboardNavigation } from '@hh.ru/magritte-common-keyboard';
import { useMultipleRefs } from '@hh.ru/magritte-common-use-multiple-refs';

const WithArrowNavigationHOC = (Component) => {
    const ComponentWithArrowNavigation = (props) => {
        const containerRef = useRef(null);
        const [activeElement, setActiveElement] = useState(null);
        const bindArrowNavigation = useKeyboardNavigation({ activeElement });
        const containerRefMultiplexer = useMultipleRefs(containerRef, bindArrowNavigation);
        /* По умолчанию useKeyboardNavigation ищет ближайший фокусабельный элемент относительно document.activeElement,
         * но при выборе даты она рендерится как disabled кнопка, поэтому не попадает в document.activeElement,
         * поэтому сохраняем ссылку на кнопку и передаем в useKeyboardNavigation напрямую
         */
        useEffect(() => {
            const container = containerRef.current;
            if (!container) {
                return void 0;
            }
            const handleFocusIn = (event) => {
                setActiveElement(event.target);
            };
            container.addEventListener('focusin', handleFocusIn);
            return () => container.removeEventListener('focusin', handleFocusIn);
        }, [setActiveElement]);
        return jsx(Component, { ...props, ref: containerRefMultiplexer });
    };
    return ComponentWithArrowNavigation;
};

export { WithArrowNavigationHOC };
//# sourceMappingURL=WithArrowNavigationHOC.js.map
